import Localization from "../../../localization";
import { Constants, Enums } from "../../../utils";
import Images from "../../../assets/images";
import React, { useCallback } from "react";
import DeviceCard from "./deviceCard";
import { Flex } from "antd";
import {
  ContentLoader,
  Container,
  ProCard,
  Button,
  Card,
  Text,
} from "../../../components";

const View = ({
  loading = false,
  subscriptions = [],
  onLearnMore = () => {},
  onClickSubscription = () => {},
  onClickPurchase = () => {},
}) => {
  const renderDevice = useCallback(
    ({ name, location, state, uuid, ...props }, index) => {
      return (
        <DeviceCard
          {...props}
          name={name}
          title={props.paymentInfo?.name}
          active={!props.deleted}
          className={`m-${!index ? 0 : 20}-t`}
          onClick={() => onClickSubscription(uuid)}
          isUnConfigured={!props.deleted && state === "unconfigured"}
          center={{ lat: location.latitude, lng: location.longitude }}
          isCardMissing={
            props.paymentInfo?.paymentMethod?.type ===
            Enums.paymentType.activation
          }
        />
      );
    },
    []
  );

  if (loading)
    return (
      <Container>
        <ContentLoader
          gap="2rem"
          skeletons={[
            { height: "31rem" },
            { height: "31rem" },
            { height: "31rem" },
          ]}
        />
      </Container>
    );
  if (!subscriptions.length)
    return (
      <Container>
        <Card background={`url(${Images.dashboardEmptyServiceCardBg})`}>
          <Text
            level={2}
            weight={700}
            lineHeight="3rem"
            children={Localization.dashboard.empty_services_title}
          />
          <Flex
            vertical
            gap={"1rem"}
            className="m-30-t"
            children={React.Children.toArray(
              [
                {
                  title: Localization.authentication.info_0_title,
                  desc: Localization.authentication.info_0_desc,
                },
                {
                  title: Localization.authentication.info_1_title,
                  desc: Localization.authentication.info_1_desc,
                },
                {
                  title: Localization.authentication.info_2_title,
                  desc: Localization.authentication.info_2_desc,
                },
                {
                  title: Localization.authentication.info_3_title,
                  desc: Localization.authentication.info_3_desc,
                },
              ].map((_) => (
                <div>
                  <Text weight={700} level={5} children={_.title} />
                  <Text type="secondary" className="m-2-t" children={_.desc} />
                </div>
              ))
            )}
          />
          <Flex className="m-30-t" gap={"1rem"}>
            <Button
              type="primary"
              title={Localization.general.purchase}
              onClick={onClickPurchase}
            />
            <Button
              className="d-none-mobile"
              onClick={onLearnMore}
              title={Localization.general.read_more}
            />
            <Button
              color="secondary"
              onClick={onLearnMore}
              className="d-none d-block-mobile"
              title={Localization.general.read_more}
            />
          </Flex>
        </Card>
      </Container>
    );
  return (
    <React.Fragment>
      <Container>
        {React.Children.toArray(subscriptions.map(renderDevice))}
        {Constants.isDev && (
          <>
            <div
              className={`m-15-${
                !!subscriptions.length ? "v" : "b"
              } text-align-center`}
            >
              <Text
                level={5}
                weight={700}
                type="secondary"
                children={Localization.dashboard.divider_title}
              />
              <Text
                type="secondary"
                children={
                  !subscriptions.length
                    ? Localization.dashboard.divider_subtitle_empty
                    : Localization.dashboard.divider_subtitle
                }
              />
            </div>
            <ProCard
              image={Images.Dashboard2}
              title={Localization.dashboard.card_2_title}
              desc={Localization.dashboard.card_2_desc}
              buttons={[
                {
                  title: Localization.general.purchase,
                  onClick: () => onClickPurchase(),
                },
                {
                  color: "tertiary",
                  title: Localization.general.learn_more,
                  onClick: onLearnMore,
                },
              ]}
            />
          </>
        )}
      </Container>
    </React.Fragment>
  );
};

export default View;
